import { View, Text, HStack, Button, Hidden, Stack, FlatList } from "native-base";
import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import { AiOutlineDownload } from "react-icons/ai";
import colors from "theme/colors";
import AmplitudeHelper from "utils/analytics";
import { LocalizationProvider } from "@mui/x-date-pickers-pro";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import TextField from "@mui/material/TextField";
import dayjs from "dayjs";

const RenderSteps = ({ templateLink = "", screenType = "", selectedDate = "", setSelectedDate = () => {} }) => {
  const { t } = useTranslation("common");
  const [error, setError] = useState("");
  const minSelectableDate = dayjs(); // .add(1, "day");
  const steps = screenType.includes("Salary Disbursement")
    ? [
        {
          text: "salaryDisbursement.steps.makeSureSelectTheTemplate",
          showTemplate: true,
        },
        {
          text: "salaryDisbursement.steps.selectExpectedSchedulingDate",
          showCalendar: true,
        },
        {
          text: "salaryDisbursement.steps.ensureTemplateDateAndFileType",
        },
        { text: "salaryDisbursement.steps.pleaseUploadYourDocument" },
      ]
    : [
        { text: "employeeCreation.bulk.selectDocumentTemplate" },
        {
          text: "employeeCreation.bulk.afterDownloadingFillDetailsAndExport",
          showTemplate: true,
        },
        { text: "employeeCreation.bulk.pleaseUploadFileInFormat" },
      ];

  const handleDownload = async () => {
    AmplitudeHelper.logEvent("download_template_clicked", {
      source: `${screenType}_page`,
    });

    fetch(templateLink)
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${screenType}.xlsx`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      })
      .catch(() => {
        // console.error("Error:", error);
      });
  };

  useEffect(() => {
    // const currentDate = new Date();
    if (selectedDate) {
      // eslint-disable-next-line no-debugger
      const selectedDateTime = parseInt(dayjs(selectedDate).format("YYYYMMDD"), 10);
      const currentDateTime = parseInt(dayjs().format("YYYYMMDD"), 10);
      if (selectedDateTime < currentDateTime) {
        setError(t("basicValidation.youCanSelectOnlyFutureDates"));
      } else {
        setError("");
      }
    }
  }, [selectedDate]);

  const renderSteps = (step) => {
    const { item = "", index = 0 } = step;
    return (
      <Stack mb="24px">
        <HStack space={2}>
          <View
            h="24px"
            w="24px"
            borderRadius="12px"
            bg={colors.secondary.orchid}
            alignItems="center"
            justifyContent="center"
            space={2}
          >
            <Text color={colors.neutral.cotton}>{index + 1}</Text>
          </View>
          <Text>{t(item?.text)}</Text>
        </HStack>
        {item?.showTemplate && (
          <HStack space={2} ml={8}>
            <Button
              variant="outline"
              rightIcon={<AiOutlineDownload size="17px" />}
              mt="8px"
              size="xs"
              onPress={handleDownload}
            >
              <Hidden till="md">
                <Text variant="xs">{t("employeeCreation.bulk.downloadTemplate")}</Text>
              </Hidden>
            </Button>
          </HStack>
        )}
        {item?.showCalendar && (
          <HStack space={2} ml={8}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                views={["year", "month", "day"]}
                disablePast
                value={selectedDate ? dayjs(selectedDate) : ""}
                minDate={minSelectableDate}
                onChange={(x) => {
                  const selectedDate = new Date(x);
                  setSelectedDate(selectedDate);
                }}
                slotProps={{
                  textField: {
                    size: "small",
                    error,
                    helperText: error,
                  },
                }}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>
          </HStack>
        )}
      </Stack>
    );
  };

  return <FlatList data={steps} contentContainerStyle={{ marginTop: 24 }} renderItem={renderSteps} />;
};

export default RenderSteps;
